export default __webpack_public_path__ + "static/media/wm1.b02d16f3.jpg";